import type { ReactNode } from 'react'

/** Shared page frame: consistent heading level, measure and spacing. */
export function MarketingPage({
  title,
  lede,
  children,
}: {
  title: string
  lede?: string
  children?: ReactNode
}) {
  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
      <h1 className="text-display text-balance">{title}</h1>
      {lede && <p className="max-w-2xl pt-4 text-body text-text-secondary">{lede}</p>}
      <div className="flex flex-col gap-10 pt-10">{children}</div>
    </div>
  )
}

export function Section({
  id,
  heading,
  children,
}: {
  id?: string
  heading: string
  children: ReactNode
}) {
  return (
    <section id={id} aria-labelledby={id ? `${id}-heading` : undefined}>
      <h2 id={id ? `${id}-heading` : undefined} className="text-h2">
        {heading}
      </h2>
      <div className="flex flex-col gap-3 pt-3">{children}</div>
    </section>
  )
}
